import type { TCreateCadastrarClienteData, TCreateCadastrarClienteResponse } from '@/shared/interfaces/cliente.types'
import { HttpService } from '@/shared/lib/http'

export class CreateCadastrarClienteService extends HttpService {
  execute = async (cadastro: Partial<TCreateCadastrarClienteData>) => {
    return this.http.post<TCreateCadastrarClienteResponse>('api/v2/Cliente/cadastrar', cadastro)
  }
}
